export interface VotacaoItem {
  codigoVotacao: number;
  token: string;
  condominio: {
    codigoCondominio: number;
    nomeCondominio: string;
  };
  dataVotacao: string;
  dataCadastro: string;
  situacao: Situacao;
  descritivoVotacao: string;
  dataLiberacaoVotacaoInicio: string;
  dataLiberacaoVotacaoFim: string;
  codigoComunicadoConvocacao: number;
  urlDoctoVotacao: string;
  formaApresentacaoResultado: EFormaApresResultado;
  linkVideo: string;
  tipoVideo: ETipoVideo;
  videoClientId: string;
  videoToken: string;
  perguntas?: Pergunta[];
  tipoExibicaoChat: TipoExibicaoChat;
  identidadeVisual: IdentidadeVisual;
  ocultarPergunta: boolean;
}

export interface Pergunta {
  codigoPergunta: number;
  codigoVotacao: number;
  textoPergunta: string;
  ordem: number;
  situacao: Situacao;
  tipoResposta: ETiposResposta;
  urlDoctoPergunta: string;
  dataLiberacaoPerguntaInicio: string;
  dataLiberacaoPerguntaFim: string;
  votoUsuario?: string[];
  justificativa?: string;
  opcaoMaisVotada?: string;
  opcoes: Opcao[];
  solicitaJustificaNaResposta: boolean;
  eventoPosVoto: EEventoPosVoto;
  podeVotar: {
    habilitado: boolean;
    motivoDesabilitado: string;
  };
  quantMaximaEscolha: number;
  quantMinimaEscolha: number;
}

export interface Opcao {
  codigoPergunta: number;
  sequencia: number;
  textoResposta: string;
  comentario: string;
}

export interface Situacao {
  codigoSituacao: number;
  descricaoSituacao: string;
}

export interface Resposta {
  codigoVotacao: number;
  codigoPergunta: number;
  condominio: number;
  unidade: string;
  resposta?: string;
  justificativa: string;
  dataCadastro?: string;
  ipOrigem?: string;
  descrOrigem?: string;
  latLong?: string;
  respostas?: string[];
}

export interface ResultadoPergunta {
  pergunta: Pergunta;
  opcoes: OpcaoComUnidade[];
  opcaoMaisVotada: OpcaoMaisVotada[];
  tipoResultado: number;
  quantidadeUnidades: number;
  baseQuantVotos: number;
  quantCasasDecimaisResultado: number;
}

interface OpcaoMaisVotada {
  quantVotos: number;
  codigoPergunta: number;
  sequencia: number;
  textoResposta: string;
  comentario: string;
  unidades?: Unidade[];
}

export interface OpcaoComUnidade extends Opcao {
  quantVotos: number;
  unidades?: Unidade[];
  tipoOpcao: ETipoOpcao;
  quantCasasDecimaisResultado: number;
}

interface Unidade {
  unidade: string;
  dataVoto: string;
  resposta: string;
}

export interface Entrada {
  tipoUsuario: number;
  assinatura: Assinatura;
  procuracao: Procuracao;
  permiteConcederProcuracao: boolean;
}

export interface Assinatura {
  codigo: number;
  data: string;
  votacao: number;
  condominio: number;
}

interface Procuracao {
  codigo: number;
  data: string;
  votacao: number;
  condominio: number;
  situacao: number;
  dataSituacao: string;
  usuarioSituacao: number;
}

export interface Assinaturas {
  votacao: number;
  condominio: number;
  unidades: string[];
  nomeAssinatura: string;
  cpfAssinatura: string;
}

export interface Procuracoes {
  codigo?: number;
  data?: string;
  votacao: number;
  condominio: number;
  unidades: string[];
  nomeProcuracao: string;
  emailProcuracao: string;
  cpfCnpjProcuracao: string;
  urlArquivoProcuracao: string;
  descrOrigemProcuracao?: string;
  situacao?: number;
  dataSituacao?: string;
  usuarioSituacao?: number;
  unidade?: string;
  descricaoSituacao?: string;
}

export enum TipoExibicaoChat {
  NaoMostrar = 0,
  BlipChat = 1,
  BlipChatApenasAreaDeslogada = 2,
  MovideskChat = 3,
  MovideskChatApenasAreaDeslogada = 4
}

export interface PreLogin {
  codigoVotacao: number;
  dataVotacao: string;
  dataCadastro: string;
  codigoComunicadoConvocacao: number;
  tipoPesoVoto: number;
  formaApresentacaoResultado: number;
  permiteOutroIpAlterarVotoUnidade: boolean;
  tipoVideo: number;
  consideraAcordoAtivoAdimplente: boolean;
  tipoExibicaoChat: TipoExibicaoChat;
  htmlHelpLogin: string;
  condominio: Condominio;
  urlModeloProcuracao: string;
  tipoLogin: number;
  identidadeVisual: IdentidadeVisual;
}

export interface IdentidadeVisual {
  headerColor: string;
  bkgColor: string;
  bkgColor2: string;
  fontColor: string;
  backgroundImage: string;
  logoPrincipal: string;
  logoTopoLogin: string;
  logoHeader: string;
  showLogoHubert: boolean;
  showNomeAssembleia: boolean;
  loginButtonBackground: string;
  linkAjuda: string;
}

interface Condominio {
  codigoCondominio: number;
  nomeCondominio: string;
}

export enum ETipoOpcao {
  OpcaoValida = 1,
  OpcaoInvalida = 2,
  UnidadesNaoVotaram = 3
}

export enum ESituacoes {
  InicioPendente = 1,
  VotacaoAberta = 3,
  VotacaoFinalizada = 4,
  VotacaoCancelada = 5
}

export enum ETiposResposta {
  ListaOpcoes = 1,
  MultiplaEscolha = 2
}

export enum EFormaApresResultado {
  Percentual_Votos_Sobre_Quant_Votos = 1,
  Quantidade_Votos = 2,
  Percentual_Votos_Sobre_Quant_Unidades = 3,
  Quantidade_Votos_Sobre_Quant_Unidades = 4
}

export enum ETipoVideo {
  SemVideo = 0,
  Zoom = 1,
  Youtube = 2,
  Link = 3,
  LiveWebinar = 4,
  Bunny = 5
}

export enum EEventoPosVoto {
  NaoDefinido = 0,
  AguardeFinalizarPergunta = 1,
  PermiteAlterarAteFechar = 2,
  VerResultadoParcial = 3
}

export enum CodTipoArquivo {
  FotosUsuario = 52,
  FotosAreaReserva = 53,
  ImagensCondominioSubsite = 54,
  AnexosNotificacoes = 55,
  AnexosCircular = 56,
  AnexosComprovanteInadimplente = 57,
  AnexosProcuracao = 58,
  DocumentosAssembleia = 59
}

export interface PostUploadRequest {
  arquivos: File[];
  codTipoArquivo: CodTipoArquivo;
}
